import React from 'react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface PaginationButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
}

export const PaginationButton = ({ children, className, ...rest }: PaginationButtonProps) => {
  return (
    <button 
      className={cn(
        "p-0 min-w-[1.5rem] h-[1.875rem] rounded-none flex items-center justify-center",
        className
      )} 
      {...rest}
    >
      {children}
    </button>
  );
};
